// core/app/javascript/controllers/demo_button_disable_controller.js
import { Controller } from "@hotwired/stimulus"

// This controller enables or disables a button based on input field content.
// The button becomes enabled only when the input field has a non-empty, non-zero string.
export default class extends Controller {
  static targets = ["input", "button"]

  connect() {
    this.toggleButton()
  }

  toggleButton() {
    const value = this.inputTarget.value.trim()
    const shouldEnable = value !== "" && value !== "0"
    this.buttonTarget.disabled = !shouldEnable
  }
}